export default {
    methods: {
        showError(error) {
            let message = error.message
            console.log('mmm', message)
            const interror = 'Internal Server Error'
            if (interror == error.message) message = 'Duplicate Detected'
            this.doToast('Error', message, 'warning')
        },
    },
}
